import { useRef, useEffect } from "react";

export const useClickOutside = (handler: () => void) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const handlerRef = useRef(handler);

  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    const handleMouseClick = (e: MouseEvent) => {
      if (containerRef.current && containerRef.current.contains(e.target as Node)) {
        return;
      }

      handlerRef.current();
    };

    document.addEventListener("click", handleMouseClick, false);
    return () => {
      document.removeEventListener("click", handleMouseClick, false);
    };
  }, []);

  return containerRef;
};
